export const AUTH_LOGIN = 'AUTH_LOGIN';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_ERROR = 'AUTH_ERROR';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';
export const REFRESH_TOKEN = 'REFRESH_TOKEN';
